import { useActionSheet } from '@expo/react-native-action-sheet';
import { useNavigation } from '@react-navigation/native';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Modals } from '../constants/ScreenNames';
import { i18nNS, useComponentTKey } from '../i18n';
import { openAlert } from '../store/actions/alert';
import { cancelTrip } from '../store/actions/payment';
import { CREW_ENABLED } from '../config/env';
import { setLoadingState } from '../store/actions/mytrips';

const useTripOptions = (
  isChangeable,
  isCancelable,
  hasNonSabreHotelBool = false,
  companySupportDetails
) => {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('InvoiceSummary');
  const options = [
    { label: t(tKey('Share')), icon: 'share', value: 'SHARE' },
    // {
    //   label: t(tKey('Change')),
    //   icon: 'change',
    //   value: 'CHANGE',
    //   disabled: isChangeable,
    // },
  ];
  if (!CREW_ENABLED) {
    options.push({ label: t(tKey('Cancel')), icon: 'cancel', value: 'CANCEL' });
  }
  const { showActionSheetWithOptions } = useActionSheet();
  const [cancelLoading, setCancelLoading] = useState(false);

  const onSelect = (value) => {
    switch (value) {
      case options[0].value:
        showActionSheetWithOptions(
          {
            options: [t(tKey('ShareWithPrice')), t(tKey('ShareWithoutPrice')), t(tKey('Cancel'))],
            cancelButtonIndex: 2,
          },
          (buttonIndex) => {
            if (buttonIndex === 0) {
              navigation.navigate(Modals.EmailItineraryModal, { withPrice: true });
            } else if (buttonIndex === 1) {
              navigation.navigate(Modals.EmailItineraryModal);
            }
          }
        );
        break;
      //   case options[1].value:
      //     if (isChangeable) {
      //       navigation.navigate(Modals.ChangeResModal);
      //     }
      //     break;
      case options[1].value:
        if (isCancelable) {
          if (hasNonSabreHotelBool) {
            const msg = 'To cancel, please call: ' + companySupportDetails.SupportContactNo;
            dispatch(
              openAlert({
                message: msg,
              })
            );
          } else {
            dispatch(
              openAlert({
                message: t(tKey('AreYouSure')),
                confirmText: t(tKey('Yes')),
                cancelText: t(tKey('No')),
                onConfirmPressed: async () => {
                  setCancelLoading(true);
                  dispatch(setLoadingState({ isLoading: true, message: 'Cancelling' }));
                  await dispatch(cancelTrip());
                  dispatch(setLoadingState({ isLoading: false }));
                  setCancelLoading(false);
                },
              })
            );
          }
        } else {
          const msg = t(tKey('CancelNotAvailable'));
          dispatch(
            openAlert({
              message: msg,
            })
          );
        }
        break;
    }
  };

  return [onSelect, options, cancelLoading];
};

export default useTripOptions;
